// extracted by mini-css-extract-plugin
export default {"item":"search_filters_bar_item-module__item--2Cb4s"};